import type { Element as XmlEl } from "@xmpp/xml"
import { NS_MAM } from "../../constants"

/** Results reach the caller that asked for them, not the live message path. */
export const isMamResult = (stanza: XmlEl): boolean =>
  !!stanza.getChild("result", NS_MAM)

export * from "./unwrap"
